import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { formatDecimalNumber } from "../../../utils";
import { roundToDecimalPlaces } from "../../../helpers/methods";

export const DiscountTotalInput = (props) => {
    const { fieldName, label, range, productPrice, readonly = false, step="any", fullWidth=false } = props;
    const { control, setValue, watch } = useFormContext();
    const { min, max } = range;

    const discountPercent = watch(fieldName) || 0;
    const [discountTotal, setDiscountTotal] = useState((productPrice * discountPercent) / 100);

    const handleSetDiscountTotal = (totalPrice) => {
        setDiscountTotal(totalPrice);
        const discountPercent = (totalPrice / productPrice) * 100;
        setValue(fieldName, discountPercent, { shouldValidate: true });
    };

    useEffect(() => {
        setDiscountTotal(roundToDecimalPlaces((productPrice * discountPercent) / 100, 2));
    }, [discountPercent, productPrice]);

    const handleTotalChange = (event) => {
        const newTotal = Number(event.target.value);

        if (Number.isNaN(newTotal) || newTotal < min) {
            handleSetDiscountTotal(min);
        } else if (newTotal > max) {
            handleSetDiscountTotal(max);
        } else {
            handleSetDiscountTotal(formatDecimalNumber(newTotal, 2));
        }
    };

    return (
        <Controller
            name={fieldName}
            control={control}
            render={() => (
                <TextField
                    type="number"
                    label={label}
                    fullWidth={fullWidth}
                    value={discountTotal}
                    onChange={handleTotalChange}
                    inputProps={{ min: min, max: max, step: step }}
                    disabled={readonly}
                />
            )}
        />
    );
};
